<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ pharmacy.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PharmacyTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Код</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.code }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.legal_entity }}</CCol>
                    </CRow>
                    <CRow
                        v-if="pharmacy.partner"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Партнер</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CLink v-if="adminOnly" :to="`/partners/${pharmacy.partner.id}`">{{ pharmacy.partner.title }}</CLink>
                            <template v-else>{{ pharmacy.partner.title }}</template>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Короткое название</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.short_title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Краткое описание</CCol>
                        <CCol sm="9" class="col-form-label" v-html="pharmacy.description"></CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для поиска</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="squarePictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Расширенное время работы (Пример: с 07:00, до 02:00 след. дня)</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.extended_schedule ? 'Включено' : 'Отключено' }}</CCol>
                    </CRow>
                    <Schedule :schedule="pharmacy.schedule" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальный заказ</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.min_price ? pharmacy.min_price : "" }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Телефон</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.phone }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки (часы)</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.delivery_time_hour }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки (минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.delivery_time }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Алиас</CCol>
                        <CCol sm="9" class="col-form-label">{{ pharmacy.alias }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(pharmacy.enabled)">
                                &nbsp;{{ pharmacy.enabled ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="stopModal = true">Стоп</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <StopServiceModal
            :id="$route.params.id"
            :open="stopModal"
            :type="BUSINESS_TYPE.PHARMACY"
            @stop-modal-close="stopModal = false"
            @stop-modal-update="setSchedule"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PharmacyTabLinks from '@/components/pharmacies/PharmacyTabLinks';
    import Schedule from '@/components/Schedule';
    import StopServiceModal from '@/components/StopServiceModal';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'Pharmacy',
        components: {
            PharmacyTabLinks,
            Schedule,
            StopServiceModal
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {});
        },

        data() {
            return {
                pharmacy: {
                    code: '',
                    title: '',
                    short_title: '',
                    description: '',
                    picture: '',
                    square_picture: '',
                    min_price: 0,
                    phone: '',
                    extended_schedule: false,
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    enabled: true,
                    position: 0,
                    data_url: '',
                },
                stopModal: false,
                BUSINESS_TYPE,
                adminOnly: false
            };
        },

        computed: {
            pictureUrl() {
                if (this.pharmacy.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.pharmacy.picture
                    );
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if (this.pharmacy.square_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.pharmacy.square_picture
                    );
                } else {
                    return '';
                }
            },
        },

        mounted() {
            this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            const id = this.$route.params.id;
            Vue.axios
                .get('/pharmacies/' + id)
                .then(resp => {
                    this.pharmacy = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            goBack() {
                this.$router.push({ path: '/pharmacies' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            setSchedule(schedule) {
                if (schedule) {
                    this.pharmacy.schedule = schedule;
                }
            }
        },
    };
</script>
